// extracted by css-extract-rspack-plugin
export default {"paymentMethodFormNotice":"PaymentMethodForm__paymentMethodFormNotice--e4sP2"};